export default __webpack_public_path__ + "static/media/012-leito da bairrada.6d869562.svg";